import {  Spinner } from "components";
import { TimedMessage } from "components/TimedMessage";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { forwardRef} from 'react';
export type ManagedStocksDeletePopupProps = {
    isDeleting: boolean; 
    showPopup: boolean;
    closeDeletePopup: () => void; 
    selectedRowsCount: number;
    ActionDelete: ()=> void;
}
export const ManagedStocksDeletePopup = forwardRef((props: ManagedStocksDeletePopupProps, ref)=>{
    
    return (
        <>        
        <Modal backdrop={props.isDeleting ? "static" : true} size="sm" centered show={props.showPopup} onHide={props.closeDeletePopup} className="modal-mdlg">
        <Modal.Header>
            <Modal.Title>Confirm</Modal.Title>
        </Modal.Header>
        <Modal.Body className={`${props.isDeleting && "disabled-div"}`}>
            <Row>
                <p>You are about to delete {props.selectedRowsCount > 1 ? " items": "item"} selected.
                 Are you sure you want to delete?</p>
            </Row>
            <Row className="pt-2 mt-1 border-top">
                <Col sm={12} className="d-flex flex-row-reverse">
                    <Button style={{alignItems: "center"}}  variant="danger" className="btn ms-1 d-flex" disabled={props.isDeleting} onClick={() => {                        
                            props.ActionDelete();                        
                    }}>
                        {props.isDeleting ? <><Spinner className="spinner-border-sm me-1" tag="span" color="white" /></> : <></>}
                        {props.isDeleting ? <>Deleting...</> : <>Delete</>}
                    </Button>
                    <Button variant="secondary" className="btn ms-1" disabled={props.isDeleting} onClick={props.closeDeletePopup}>Cancel</Button>    
                    <TimedMessage message="Please wait while we delete your items..." delay={1} enabled={props.isDeleting} className="mb-0 py-1 px-2" />
                </Col>
            </Row>
        </Modal.Body>
    </Modal>
        
        </>
    );
});